export default "__VITE_ASSET__doLnO6mu__"